var map = {
	"./avatar-1.jpg": "c3eb",
	"./avatar-2.jpg": "95f5",
	"./avatar-3.jpg": "61ae",
	"./avatar-4.jpg": "1f62",
	"./avatar-5.jpg": "a8a4",
	"./avatar-6.jpg": "d03b",
	"./avatar-7.jpg": "cd5e",
	"./avatar-8.jpg": "9f20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a8f";